import React from 'react';
import moment from 'moment';
import './paquete-detalle-transporte.css';

const Transporte = (props) => {
  const getDate = (value, format, returnedText = '', appendedText = '') => {
    if (
      value === null
      || value === '0001-01-01T00:00:00'
      || value === undefined
    ) {
      return returnedText;
    }
    if (format.toUpperCase().includes('H') && value.includes('00:00:00')) {
      return returnedText;
    }
    return `${moment(value).format(format)} ${appendedText}`;
  };

  let diaS = '-';
  let mesS = '-';
  let diaL = '-';
  let mesL = '-';
  let horaS = '-';
  let horaSS = '-';
  let horaL = '-';
  let horaLL = '-';

  if (props.salida.transporte.transporteAereo !== null) {
    if (props.salida.transporte.transporteAereo.itinerarioVuelo == null) {
      diaS = getDate(props.salida.fechaSalida, 'ddd D');
      mesS = getDate(props.salida.fechaSalida, 'MMM YYYY');
      diaL = getDate(props.salida.fechaLlegada, 'ddd D');
      mesL = getDate(props.salida.fechaLlegada, 'MMM YYYY');
      horaS = getDate(props.salida.horaSalida, 'HH:mm');
      horaSS = getDate(props.salida.horaLlegada, 'HH:mm');
      horaL = getDate(props.salida.horaSalida, 'HH:mm');
      horaLL = getDate(props.salida.horaLlegada, 'HH:mm');
    } else {
      diaS = getDate(props.salida.transporte.transporteAereo.itinerarioVuelo.informeIda.segmentoPrincipal.fechaSalida, 'ddd D');
      mesS = getDate(props.salida.transporte.transporteAereo.itinerarioVuelo.informeIda.segmentoPrincipal.fechaSalida, 'MMM YYYY');
      diaL = getDate(props.salida.transporte.transporteAereo.itinerarioVuelo.informeVuelta.segmentoPrincipal.fechaLlegada, 'ddd D');
      mesL = getDate(props.salida.transporte.transporteAereo.itinerarioVuelo.informeVuelta.segmentoPrincipal.fechaLlegada, 'MMM YYYY');
      horaS = getDate(props.salida.transporte.transporteAereo.itinerarioVuelo.informeIda.segmentoPrincipal.fechaSalida, 'HH:mm');
      horaSS = getDate(props.salida.transporte.transporteAereo.itinerarioVuelo.informeIda.segmentoPrincipal.fechaLlegada, 'HH:mm');
      horaL = getDate(props.salida.transporte.transporteAereo.itinerarioVuelo.informeVuelta.segmentoPrincipal.fechaSalida, 'HH:mm');
      horaLL = getDate(props.salida.transporte.transporteAereo.itinerarioVuelo.informeVuelta.segmentoPrincipal.fechaLlegada, 'HH:mm');
    }
  } else {
    // SI NO VIENE EL ITINERARIO COMPLETO NO SE MUESTRA NADA
    return (
      <></>
    );
  }

  return (
    <>
      <div className='simplification'>
        {props.origen}
        -
        {props.destino}
        {/* {props.transporte.transporteAereo.nombreLineaAerea !== null ? <span> Empresa: <b>{props.transporte.transporteAereo.nombreLineaAerea}</b></span> : null} */}
      </div>
      <div className='box-seg'>
        <div className='item-content in-left'>
          <span className='container-icon color-dinamico-fondo'>
            <i className='fa fa-arrow-right' />
          </span>
          <span>
            <span className='uppercase'>{diaS}</span>
            de
            <span className='uppercase'>{mesS}</span>
          </span>
          <i className='fa fa-chevron-right' style={{ padding: '0 9px' }} />
        </div>
        <div className='item-content middle'>
          <span className='internal-items'>
            <b>
              {`${horaS} hs`}
              {' '}
              hs
              {' '}
              {props.origen}
            </b>
            {' '}
            -
            <b>
              {horaSS}
              {' '}
              hs
              {' '}
              {props.destino}
            </b>
          </span>
        </div>
        <div className='item-content in-left'>
          <i className='fa fa-chevron-right' style={{ padding: '0 9px' }} />
          <span className='container-icon color-dinamico-fondo'>
            <i className='fa fa-arrow-left ' />
          </span>
          <span>
            <span className='uppercase'>{diaS}</span>
            {' '}
            de
            <span className='uppercase'>{mesS}</span>
          </span>
        </div>
      </div>
      <div className='box-seg'>
        <div className='item-content in-left'>
          <span className='container-icon color-dinamico-fondo'>
            <i className='fa fa-arrow-right' />
          </span>
          <span>
            <span className='uppercase'>{diaL}</span>
            {' '}
            de
            <span className='uppercase'>{mesL}</span>
          </span>
          <i className='fa fa-chevron-right' style={{ padding: '0 9px' }} />
        </div>
        <div className='item-content middle'>
          <span className='internal-items'>
            <b>
              {horaL}
              {' '}
              hs
              {' '}
              {props.destino}
            </b>
            {' '}
            -
            <b>
              {horaLL}
              {' '}
              hs
              {' '}
              {props.origen}
            </b>
          </span>
        </div>
        <div className='item-content in-left'>
          <i className='fa fa-chevron-right' style={{ padding: '0 9px' }} />
          <span className='container-icon color-dinamico-fondo'>
            <i className='fa fa-arrow-left ' />
          </span>
          <span>
            <span className='uppercase'>{diaL}</span>
            {' '}
            de
            <span className='uppercase'>{mesL}</span>
          </span>
        </div>
      </div>
    </>
  );
};
export default Transporte;
